export default {
  apiKey: 'AIzaSyBS1H7eOr3amFYFzf6Hta0Byuo7_Pqwcqk',
  authDomain: 'ntabi-somen-b2b.firebaseapp.com',
  databaseURL: 'https://ntabi-somen-b2b.firebaseio.com',
  projectId: 'ntabi-somen-b2b',
  storageBucket: 'ntabi-somen-b2b.appspot.com',
  messagingSenderId: '73101154768',
  appId: '1:73101154768:web:f961627fd6787e1dc5c1d5',
  measurementId: 'G-LD6SPN4GDP'
}
